import React, { FunctionComponent, SVGAttributes } from 'react';

export const GridIconSvg: FunctionComponent<SVGAttributes<SVGElement>> = (props) => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='currentColor' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18 0H2C0.89543 0 0 0.89543 0 2V18C0 19.1046 0.89543 20 2 20H18C19.1046 20 20 19.1046 20 18V2C20 0.89543 19.1046 0 18 0ZM2 18V11H9V18H2ZM11 18H18V11H11V18ZM11 9H18V2H11V9ZM9 2H2V9H9V2Z'
    />
  </svg>
);
